import React from 'react'
import { cn } from '@/lib/utils'
import { paceBand, paceComparison } from '@/lib/plain-language'

interface PaceDotProps {
  paceRatio: number | null | undefined
  /** Optional context so the tooltip can read "Ahead · 32% full · usually ~61% by now". */
  occPct?: number | null
  baselinePct?: number | null
  className?: string
}

export default function PaceDot({ paceRatio, occPct, baselinePct, className }: PaceDotProps) {
  if (paceRatio == null) return null
  if (paceRatio > 0.90 && paceRatio < 1.10) return null

  // Worded, never a bare multiplier (docs/revenue-vocabulary.md § Plain-language presentation).
  const band = paceBand(paceRatio)
  const comparison = paceComparison(occPct, baselinePct)
  const title = comparison ? `${band.label} · ${comparison}` : band.label

  return (
    <span
      className={cn(
        'inline-block h-1.5 w-1.5 rounded-full',
        paceRatio >= 1.10 ? 'bg-emerald-500' : 'bg-rose-500',
        className
      )}
      title={title}
    />
  )
}
